import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createBladeModel, getBladeModelAPI , removeBladeModel , updateBladeModel} from '../api/util';
import { RootState } from '../store';


export interface ProjectState {
    bladeModelList?: any[],
    newProjectResponse?:any,
    fetching: boolean,
}

const initialState: ProjectState = {
    bladeModelList: undefined,
    fetching:false

}


export const createNewModel = createAsyncThunk(
    'bladeModal/createNewModel',
    async (data: any, thunkAPI) => {
        try {
            const response = await createBladeModel(data); // Assuming createBladeModel is an asynchronous function
            console.log("createNewModel", response.response);
            return response.response;
        } catch (error) {
            console.log("createNewModel", error);
            return error;
        }
    }
);
export const updateNewBladeModel = createAsyncThunk(
    'bladeModal/updateNewProject',
    async (data: any) => {
        const response = await updateBladeModel(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);


export const removenewBladeModel = createAsyncThunk(
    'bladeModal/removenewBladeModel',
    async (data: any) => {
        const response = await removeBladeModel(data);
        console.log("createNewModel",response.response)
        return response.response;
    }
);

export const getBladeModels = createAsyncThunk(
    'bladeModal/getBladeModels',
    async () => {
        const response = await getBladeModelAPI();
        console.log("getBladeModels",response.response)
        return response.response;
    }
);


export const BladeModelSlice = createSlice({
    name: 'bladeModel',
    initialState,
    reducers: {
        resetBladeModelStore: (state) => {
            state = initialState;
        }
    }, extraReducers: (builder) => {
        builder
            .addCase(getBladeModels.pending, (state) => {
                state.fetching = true;
                state.bladeModelList = undefined
            })
            .addCase(getBladeModels.fulfilled, (state, action) => {
                state.fetching = false;
                state.bladeModelList = action.payload.data;
            })
            .addCase(getBladeModels.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(updateNewBladeModel.pending, (state) => {
                state.fetching = true;
                state.bladeModelList = undefined
            })
            .addCase(updateNewBladeModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.bladeModelList = action.payload.data;
            })
            .addCase(updateNewBladeModel.rejected, (state) => {
                state.fetching = false;
            })


            .addCase(removenewBladeModel.pending, (state) => {
                state.fetching = true;
                state.bladeModelList = undefined
            })
            .addCase(removenewBladeModel.fulfilled, (state, action) => {
                state.fetching = false;
                state.bladeModelList = action.payload.data;
            })
            .addCase(removenewBladeModel.rejected, (state) => {
                state.fetching = false;
            })

            .addCase(createNewModel.pending, (state,action) => {
                state.fetching = true;
                state.newProjectResponse = undefined
            })
            .addCase(createNewModel.fulfilled, (state, action) => {
              
                state.fetching = false;
                state.newProjectResponse = action.payload
            })
            .addCase(createNewModel.rejected, (state,action) => {
                state.fetching = false;
                state.newProjectResponse = action.error.message ;
            })
    }
})


export const { resetBladeModelStore } = BladeModelSlice.actions;

export const getBladeModelList = (state: RootState) => state.bladeModel.bladeModelList;
export const newProjectResponse = (state: RootState) => state.bladeModel.newProjectResponse;


export default BladeModelSlice.reducer;